import React from 'react'

import { Box, Flex, Link, Text } from '@driftt/dds'

import { ActivityEndUser } from 'modules/accountActivity/domain'
import { getEndUserDisplayName } from 'utils/endUser'
import { conversationPath } from 'utils/paths'

export const ConversationContent = ({
  conversationPreview,
  convoId,
  endUser,
  trackAction
}: {
  conversationPreview: string
  convoId: string | undefined
  endUser: ActivityEndUser
  trackAction: (action: string, additionalData?: any) => void
}) => {
  const endUserDisplayName = getEndUserDisplayName(endUser)
  return (
    <Flex direction="column" css={{ marginTop: '16px' }}>
      <Text variant="metadata">{endUserDisplayName}</Text>
      <Box
        css={{
          backgroundColor: '$gray2',
          borderRadius: '3px',
          padding: '8px',
          width: '100%'
        }}>
        <Link
          href={conversationPath(convoId)}
          target="_blank"
          onClick={() => trackAction('Conversation preview click')}>
          <Text css={{ textWrap: 'wrap', wordBreak: 'normal', width: '100%' }} truncate>
            {conversationPreview}
          </Text>
        </Link>
      </Box>
    </Flex>
  )
}
